module.exports = __webpack_public_path__ + "img/bottom_left.7cae65aa.png";